import clsx from 'clsx';
import type * as React from 'react';

import type * as api from '@gitbook/api-client';
import type { Organization } from '@gitbook/app-database';
import { Icon } from '@gitbook/spine-icons';
import { Image } from '@gitbook/spine-react';

export type OrganizationIconProps = {
    organization: api.Organization | Organization;
    size?: number;
    className?: string;
};

/**
 * Icon for an organization.
 */
export function OrganizationIcon(props: OrganizationIconProps): React.ReactElement {
    const { organization, size = 32, className } = props;

    const logoURL = 'urls' in organization ? organization.urls.logo : organization.logoURL;

    if (!logoURL) {
        return <DefaultOrganizationIcon size={size} className={className} />;
    }

    return (
        <Image
            src={logoURL}
            className={clsx('rounded-sm bg-muted', className)}
            rounded={false}
            width={size}
            height={size}
        />
    );
}

/**
 * Default icon for an organization.
 */
export function DefaultOrganizationIcon(props: {
    size?: number;
    className?: string;
}): React.ReactElement {
    const { size = 32, className } = props;

    return (
        <div
            className={clsx('flex items-center justify-center rounded-sm bg-muted', className)}
            style={{
                width: size,
                height: size,
            }}
        >
            <Icon.Users style={{ width: size * 0.7, height: size * 0.7 }} className="text-muted" />
        </div>
    );
}
